export const PRODUCT_STATUSES = `
query productStatuses(
  $tenant_id: Int!,
  $skip: Int,
  $take: Int,
  $orderBy: ProductStatusOrderInput
){
  productStatuses(
    tenant_id:$tenant_id,
    skip:$skip,
    take:$take,
    orderBy:$orderBy
  ){
    __typename
    ...on ProductStatus{
      id
      name
      translation_key
      position
      hex_color      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
      
    }
  }
}
`;
